import httpClient from "../httpClient";
const getCosts = () => httpClient.get(`/costs/`)
const postCosts = (params) => httpClient.post(`/costs/add-cost/`, params)
const putCosts = (params) => httpClient.put(`/costs/update-cost/`, params)
const deleteCosts = (id) => httpClient.delete(`/costs/delete-cost/?cost_id=${id}`, )

const listCost = () => httpClient.get(`/costs/list-cost/?page_size=-1`)

const abstractMonthlyCosts = () => httpClient.get(`/costs/abstract-monthly-costs/`)


export {
    getCosts,
    postCosts,
    putCosts,
    deleteCosts,
    abstractMonthlyCosts,
    listCost,
    
}
